import { useDispatch } from "react-redux";
import CheckoutFinishedView from "./view";
import { useEffect } from "react";
import { clearUser } from "@/redux/ducks/user";
import { openApp } from "@/utils/functions";
import { useNavigate } from "react-router-dom";
import useTicket from "@/hooks/useTicket";
import useMundialeChat from "@/hooks/useMundialeChat";

export default function CheckoutFinished() {
  useMundialeChat();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    isLoading,
    openPaymentReceipt,
    generatePDF,
    invoice,
    toggleModal,
    isVisibleModal,
    errorTickets,
    errorInvoice,
  } = useTicket();

  const goToPlayStore = () => {
    openApp("android");
  };

  const goToAppleStore = () => {
    openApp("ios");
  };

  const goToTickets = () => navigate("/ticket/pin");

  const goBack = () => navigate("/");

  const openInvoice = () => {
    openPaymentReceipt();
  };

  useEffect(() => {
    return () => {
      dispatch(clearUser());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CheckoutFinishedView
      goToPlayStore={goToPlayStore}
      goToAppleStore={goToAppleStore}
      goBack={goBack}
      goToTickets={goToTickets}
      invoice={invoice}
      toggleModal={toggleModal}
      toggleModalRegister={() => {
        navigate("/register");
      }}
      generatePDF={generatePDF}
      isVisibleModal={isVisibleModal}
      isLoading={isLoading}
      openInvoice={openInvoice}
      error={errorTickets || errorInvoice}
      toggleError={toggleModal}
      handleTryAgain={() => {
        toggleModal();
        openInvoice();
      }}
    />
  );
}
